exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-sidebar .sidebar-menu .menu-items > li ul.sub-menu {\n  margin: 0;\n  padding: 0; }\n  .page-sidebar .sidebar-menu .menu-items > li ul.sub-menu > :first-child {\n    margin-top: 19px; }\n  .page-sidebar .sidebar-menu .menu-items > li ul.sub-menu > :last-child {\n    margin-bottom: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/components/menu/menu.component.scss
// module id = ../../../../../src/app/@hornbillfx/components/menu/menu.component.scss
// module chunks = main